<template>
  <administration-layout>
    <LoadingScreen :isLoading="loading"></LoadingScreen>
    <div class="flex flex-col items-center py-4">
      <div class="w-full xl:px-36 sm:px-8">
        <div class="membership-heading flex flex-row items-center py-4">
          <h1 class="text-lg font-bold inline-flex items-center px-3 py-3">
            <strong>Mi Membresia</strong>
          </h1>
        </div>
        <div class="flex flex-col">
          <content-card slotCustomClass="flex flex-col lg:flex-row" class="membership-overview mb-4">
            <div class="membership-plan-panel w-full lg:w-1/3 lg:mr-2">
              <span class="membership-eyebrow">ESTADO ACTUAL</span>
              <strong class="membership-plan-title">Tu plan:</strong>
              <div class="w-full">
                <el-button size="sm" class="w-full" :class="existsPayment ? 'el-button--primary' : ''"
                  @click="viewPayment">
                  {{
                    existsPayment
                      ? "Administrar mi suscripción " +
                      membershipTypes[$store.state.account.membershipType]
                      : "Contrata tu plan"
                  }}
                </el-button>
                <el-button v-if="isOwner" size="sm" class="w-full mt-2 cancel-membership-button"
                  @click="cancellationDialogVisible = true">
                  Cancelar mi suscripción
                </el-button>
              </div>
            </div>
            <div class="membership-date-panel w-full lg:w-1/3 lg:ml-2 lg:mr-2">
              <div class="membership-date-heading">
                <span class="membership-panel-icon"><i class="bx bx-log-in-circle"></i></span>
                <strong>Vence el día:</strong>
              </div>
              <div class="w-full">
                <el-date-picker v-model="$store.state.account.membershipEndDate" type="date" disabled
                  :format="$store.state.business.dateFormat" class="w-full bg-select-button">
                </el-date-picker>
              </div>
            </div>
            <div class="membership-date-panel membership-last-payment w-full lg:w-1/3 lg:ml-2" v-if="existsPayment">
              <strong>Ultimo pago:</strong>
              <div class="w-full flex flex-row">
                <el-date-picker v-model="$store.state.account.membershipLastPay.createdAt" type="date" disabled
                  :format="$store.state.business.dateFormat" class="w-full bg-select-button">
                </el-date-picker>
              </div>
            </div>
          </content-card>
          <div class="membership-sync-banner text-center">
            <span class="text-sm text-gray-600 mb-1">¿Ya realizaste tu pago? </span>
            <span class="text-sm text-purple-600 cursor-pointer flex items-center justify-center gap-2"
              @click="syncStripeAccount">
              <i class="bx bx-info-circle"></i>
              Si no se ha visto reflejado, da click aquí
            </span>
          </div>
          <content-card v-if="existsPayment">
            <div class="flex flex-row items-center">
              <span class="text-lg font-bold">Detalles de tu ultimo Pago</span>
            </div>
            <div class="block w-full overflow-x-auto">
              <table class="items-center w-full border-collapse">
                <thead>
                  <tr class="px-2 border-b-2">
                    <th class="py-3 font-bold text-left border-l-0 border-r-0 whitespace-nowrap">
                      Fecha
                    </th>
                    <th class="py-3 font-bold text-left border-l-0 border-r-0 whitespace-nowrap">
                      Tipo
                    </th>
                    <th class="py-3 font-bold text-left border-l-0 border-r-0 whitespace-nowrap">
                      Monto
                    </th>
                    <th class="py-3 font-bold text-left border-l-0 border-r-0 whitespace-nowrap">
                      Tipo de Moneda
                    </th>
                    <th class="py-3 font-bold text-left border-l-0 border-r-0 whitespace-nowrap">
                      Estatus
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="cursor-pointer hover:bg-gray-100 hover:shadow">
                    <td class="p-2 border-t" style="min-width: 125px">
                      {{ lastPayDate }}
                    </td>
                    <td class="p-2 border-t" style="min-width: 125px">
                      {{ lastPayType }}
                    </td>
                    <td class="p-2 border-t" style="min-width: 125px">
                      {{ moneyFormat(lastPayAmount) }}
                    </td>
                    <td class="p-2 border-t" style="min-width: 125px">
                      {{ lastPayCurrency }}
                    </td>
                    <td class="p-2 border-t" style="min-width: 125px">
                      <div class="text-center rounded-lg text-white" :class="$store.state.account.membershipLastPay.succeeded
                        ? 'success'
                        : 'failed'
                        ">
                        {{ lastPayStatus }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </content-card>

        </div>
      </div>
    </div>

    <membership-cancellation v-model="cancellationDialogVisible" />
  </administration-layout>
</template>
<style>
.membership-heading { justify-content: space-between; margin-bottom: 10px; }
.membership-heading h1 { color: #172554; font-size: 28px; letter-spacing: -.02em; }
.membership-heading strong { font-weight: 800; }
.membership-heading::after { content: "Cuenta y facturación"; color: #8b2b96; font-size: 11px; font-weight: 700; letter-spacing: .12em; margin-right: 18px; }
.membership-overview { display: block !important; padding: 15px !important; border: 0 !important; border-radius: 10px !important; background: linear-gradient(115deg, #7433ec 0%, #8622df 100%) !important; box-shadow: 0 8px 18px rgba(91, 35, 190, .25) !important; }
.membership-overview > div:last-child { display: grid !important; grid-template-columns: minmax(320px, 1.5fr) minmax(270px, .95fr); gap: 15px; align-items: stretch; }
.membership-plan-panel { width: auto !important; min-height: 160px; padding: 31px 32px 25px; border-radius: 9px; background: transparent; color: #fff; }
.membership-eyebrow { display: block; margin-bottom: 5px; color: rgba(255,255,255,.72); font-size: 10px; font-weight: 700; }
.membership-plan-panel strong.membership-plan-title { display: block; margin-bottom: 16px; color: #fff; font-size: 28px; line-height: 1.1; }
.membership-plan-panel .el-button { width: auto !important; min-width: 128px; height: 33px; padding: 0 16px; border: 0; border-radius: 6px; font-size: 11px; }
.membership-plan-panel .el-button--primary { color: #5726cb !important; background: #fff !important; }
.membership-plan-panel .cancel-membership-button { color: #fff !important; background: rgba(120, 71, 219, .55) !important; border: 1px solid rgba(255,255,255,.16) !important; }
.membership-date-panel { width: auto !important; margin: 0 !important; display: flex; flex-direction: column; align-items: stretch; justify-content: center; gap: 10px; padding: 14px 16px; border-radius: 9px; background: rgba(255,255,255,.13); box-shadow: inset 0 0 0 1px rgba(255,255,255,.16); color: #fff; }
.membership-date-heading { display: flex; align-items: center; gap: 9px; }
.membership-date-panel > div { min-width: 0; }
.membership-date-panel strong { display: block; color: #fff; font-size: 16px; }
.membership-date-panel .membership-panel-icon { display: flex; align-items: center; justify-content: center; width: 34px; height: 34px; border-radius: 50%; background: rgba(255,255,255,.2); color: #fff; font-size: 20px; }
.membership-date-panel .el-date-editor { width: 100% !important; }
.membership-date-panel .el-input__inner { height: 49px; border: 1px solid rgba(255,255,255,.08); border-radius: 6px; background: rgba(137, 77, 224, .65); color: #fff; font-size: 23px; font-weight: 800; }
.membership-date-panel .el-input__prefix { color: rgba(255,255,255,.8); }
.membership-last-payment { display: none; }
.membership-sync-banner { display: flex; align-items: center; justify-content: center; gap: 10px; width: 100%; padding: 15px 20px; border: 1px solid #e5d5ec; border-radius: 13px; background: #fbf8fd; color: #6d287d; cursor: pointer; transition: .2s; }
.membership-sync-banner:hover { background: #f4eafa; transform: translateY(-1px); }
.membership-sync-banner small { display: block; color: #718096; margin-top: 2px; }
.membership-sync-icon { font-size: 20px; }
.membership-sync-arrow { font-size: 20px; font-weight: 700; }
@media (max-width: 700px) { .membership-overview > div:last-child { grid-template-columns: 1fr; } .membership-plan-panel { min-height: auto; padding: 24px 20px; } .membership-heading::after { display: none; } }
.success {
  background-color: forestgreen;
}

.failed {
  background-color: firebrick;
}

.cancel-membership-button {
  color: #8b2b96 !important;
  border-color: #c9a1d0 !important;
}

</style>
<script>
import _ from "lodash";
import error from "@/mixins/error";
import numbers from "@/utils/numbers";
import { MembershipEnum, AccountTypeEnum } from "@/constants";
import PaymentService from "@/services/PaymentService";
import PaymentDialogService from "@/components/dialogs/Payment/service";
import MembershipCancellation from "@/components/dialogs/MembershipCancellation";

export default {
  name: "Membership",
  mixins: [error],
  components: {
    AdministrationLayout: () =>
      import("@/components/organisms/TheAdministrationApp"),
    ContentCard: () => import("@/components/molecules/ContentCard"),
    LoadingScreen: () => import("@/components/layouts/LoadingScreen"),
    MembershipCancellation,
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
      visibleLastPaymentDetails: false,
      cancellationDialogVisible: false,
      membershipTypes: {
        [MembershipEnum.Basic]: "Básico",
        [MembershipEnum.Professional]: "Profesional",
        [MembershipEnum.Premium]: "Premium",
      },
    };
  },
  watch: {
    errorMessage: {
      deep: true,
      handler: _.debounce(async function () {
        if (this.errorMessage) {
          await this.$toastr.e(this.errorMessage);
          this.errorMessage = undefined;
        }
      }, 300),
    },
  },
  computed: {
    existsPayment() {
      return this.$store.state.account.membershipLastPay.createdAt;
    },
    lastPayDate() {
      const format =
        this.$store.state.business.dateFormat?.toUpperCase() ?? "MM/DD/YYYY";
      return this.$moment(
        new Date(this.$store.state.account.membershipLastPay.createdAt)
      ).format(format);
    },
    lastPayType() {
      return (
        {
          payment_intent: "Pago",
        }[this.$store.state.account.membershipLastPay.object] || "Pago"
      );
    },
    lastPayAmount() {
      return this.$store.state.account.membershipLastPay.amount / 100;
    },
    lastPayCurrency() {
      return this.$store.state.account.membershipLastPay.currency.toUpperCase();
    },
    lastPayStatus() {
      return this.$store.state.account.membershipLastPay.succeeded
        ? "Exitoso"
        : "Fallido";
    },
    isOwner() {
      return this.$store.state.account.accountType === AccountTypeEnum.Owner;
    },
  },
  methods: {
    async syncStripeAccount() {
      try {
        this.loading = true;
        await PaymentService.syncStripeAccount(this.$store.state.account.id);
        this.$swal.fire({
          title: "Cuenta sincronizada.",
          icon: "success",
          text: "El proceso de sincronización se ha completado exitosamente. Si realizaste un pago recientemente, debería reflejarse en tu cuenta ahora.",
          timer: 10000,
          timerProgressBar: true,
          confirmButtonText: "Aceptar"
        }).then(() => {
          window.location.reload();
        });
      } catch (error) {
        this.handleError(error);
        this.$swal.fire({
          title: "Error al sincronizar.",
          icon: "error",
          text: "Hubo un error al sincronizar la información de tu cuenta. Por favor, intenta nuevamente más tarde.",
        });
      }
      finally {
        this.loading = false;
      }

    },
    viewPayment() {
      if (this.$store.state.account.accountType !== AccountTypeEnum.Owner) {
        this.$swal.fire({
          title: "Acceso Denegado.",
          icon: "error",
          text: "Los pagos se deben realizar desde la cuenta madre (Dueño) con la que se inicio en samii.",
        });
        return;
      }
      if (this.existsPayment) {
        const url_with_email = this.$store.state.account.stripeCustomerUrl;
        window.open(url_with_email, "_blank");
        return;
      }
      PaymentDialogService.show();
    },
    moneyFormat(value) {
      const { currencySymbol } = this.$store.state.account;
      return numbers.moneyFormat(value, currencySymbol);
    },
    confirmUnsubscribe() {
      this.$confirm(`¿Está seguro que deseas cancelar tu subscripcion?`, {
        type: "warning",
        confirmButtonText: "Si",
        cancelButtonText: "No",
      }).then(async () => {
        await this.unsubscribe();
      });
    },
    async unsubscribe() {
      try {
        await PaymentService.unsubscribe();
        this.$toastr.s("Has cancelado tu subscripcion");
      } catch (e) {
        this.errorMessage = this.getErrorMessage(e);
      }
    },
  },
};
</script>
